import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import {
  NotiViewContent,
  NotiViewHeader,
  NotiViewBack,
  NotiViewTitle,
  NotiViewBoard,
  NotiTitle,
  NotiDate,
  NotiContent
} from "./NoticeView.styles";
import { noticeService, NoticeDetail } from "services/noticeService";

export default function NoticeView() {
  const [notiViewData, setNotiViewData] = useState<NoticeDetail | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    if (!id) {
      setError("공지사항 ID가 없습니다.");
      setLoading(false);
      return;
    }

    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await noticeService.getNoticeDetail(Number(id));
        setNotiViewData(data);
      } catch (error) {
        console.error("공지사항 보기 데이터를 가져오는 중 오류 발생:", error);
        setError("공지사항을 불러올 수 없습니다.");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id]);

  const handleBackClick = () => {
    window.history.back();
  };

  return (
    <NotiViewContent>
      <NotiViewHeader>
        <NotiViewBack onClick={handleBackClick}>
          <FontAwesomeIcon icon={faChevronLeft} style={{ fontSize: '1.5em' }} />
        </NotiViewBack>
        <NotiViewTitle>공지사항</NotiViewTitle>
      </NotiViewHeader>
      {loading ? (
        <div style={{ textAlign: 'center', padding: '2rem', color: '#666' }}>
          공지사항을 불러오는 중...
        </div>
      ) : error ? (
        <div style={{ textAlign: 'center', padding: '2rem', color: '#666' }}>
          {error}
        </div>
      ) : notiViewData ? (
        <NotiViewBoard>
          <NotiTitle>{notiViewData.title}</NotiTitle>
          <NotiDate>공지일 | {notiViewData.date}</NotiDate>
          <NotiContent dangerouslySetInnerHTML={{ __html: notiViewData.content.replace(/\n/g, '<br />') }} />
        </NotiViewBoard>
      ) : (
        <div style={{ textAlign: 'center', padding: '2rem', color: '#666' }}>
          공지사항을 찾을 수 없습니다.
        </div>
      )}
    </NotiViewContent>
  );
}
